import { $menu } from "./menu";

export default function toggleMenu() {
    const isVisible = $menu.style.display !== "none";
    const shadowRoot = $menu.getRootNode() as ShadowRoot;
    const $overlay = shadowRoot.querySelector('.cya11y-overlay') as HTMLElement;
    
    if(String($menu.style.display)!=='none' || isVisible){
        $menu.style.display = "none";
        $overlay.style.display = "none";
        
        // Clean up escape key handler
        if (($menu as any)._escapeKeyHandler) {
            document.removeEventListener('keydown', ($menu as any)._escapeKeyHandler);
            delete ($menu as any)._escapeKeyHandler;
        }
        
        // Update widget button ARIA expanded state
        const widgetContainer = document.querySelector('.cya11y-container');
        if (widgetContainer) {
            const widgetShadowRoot = widgetContainer.shadowRoot;
            if (widgetShadowRoot) {
                const widgetButton = widgetShadowRoot.querySelector('.cya11y-menu-btn') as HTMLElement;
                if (widgetButton) {
                    widgetButton.setAttribute('aria-expanded', 'false');
                }
            }
        }
    }
    else{
        $menu.style.display = "block";
        $overlay.style.display = "block";
        
        // Update widget button ARIA expanded state
        const widgetContainer = document.querySelector('.cya11y-container');
        if (widgetContainer) {
            const widgetShadowRoot = widgetContainer.shadowRoot;
            if (widgetShadowRoot) {
                const widgetButton = widgetShadowRoot.querySelector('.cya11y-menu-btn') as HTMLElement;
                if (widgetButton) {
                    widgetButton.setAttribute('aria-expanded', 'true');
                }
            }
        }
    }
}